var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnchor13168641(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 683,
    viewBox: "0 0 683 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1829_641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M682.667 341.333C682.667 529.849 529.849 682.667 341.333 682.667C152.818 682.667 0 529.849 0 341.333C0 152.818 152.818 0 341.333 0C529.849 0 682.667 152.818 682.667 341.333Z",
    fill: "#2490CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.725 680.505C533.887 663.245 656.991 543.328 679.1 390.687L392.189 102.552L313.647 110.51L294.98 186.016L325.866 218.922L332.335 276.328L272.694 287.344L341.095 354.052L356.199 504.042L193.121 493.901L379.725 680.505Z",
    fill: "#0874B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.335 498.651V287.344H409.975V247.344H361.335V203.807C388.048 196.005 407.579 171.854 407.579 143.344C407.579 108.531 378.486 80.2083 342.72 80.2083C306.96 80.2083 277.866 108.531 277.866 143.344C277.866 170.859 296.053 194.307 321.335 202.927V247.344H272.694V287.344H321.335V498.651C239.449 472.885 98.668 325.568 98.668 325.568C98.668 325.568 123.809 505.12 341.335 585.12C558.861 505.12 584.001 325.568 584.001 325.568C584.001 325.568 443.22 472.885 361.335 498.651ZM342.72 120.214C356.428 120.214 367.579 130.589 367.579 143.344C367.579 156.099 356.428 166.474 342.72 166.474C329.017 166.474 317.866 156.099 317.866 143.344C317.866 130.589 329.017 120.214 342.72 120.214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.333 585.12C558.859 505.12 584 325.568 584 325.568C584 325.568 443.219 472.885 361.333 498.651V287.344H409.974V247.344H361.333V203.807C388.047 196.005 407.578 171.854 407.578 143.344C407.578 108.531 378.484 80.2083 342.719 80.2083C342.172 80.2083 341.625 80.2396 341.078 80.25V120.286C341.625 120.255 342.167 120.208 342.719 120.208C356.427 120.208 367.578 130.589 367.578 143.344C367.578 156.094 356.427 166.474 342.719 166.474C342.167 166.474 341.625 166.427 341.078 166.396L341.333 585.12Z",
    fill: "#EBF2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1829_641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682.667,
    height: 682.667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchor13168641);
export default __webpack_public_path__ + "static/media/anchor_1316864 1.2d783a9e85f97451c9ca9e6a8e8a1a50.svg";
export { ForwardRef as ReactComponent };